import { useState } from "react";

// This is a 200x200 grey image to be used as a placeholder until the desired image is loaded.
// This was generated https://via.placeholder.com/200x200.png?text=%20. The choice of 200x200 is
// because the ImageLane sets a maximum height of 200px on all images.
const placeholderImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEXMzMyWlpYU2uzL" +
  "AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAHElEQVRYhe3BgQAAAADDoPlTX+EAVQEAAAAAfAYUUAABHmXVxwAAAABJRU5ErkJggg==";

const StableImage = ({ img, className, onClick, height }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded ? (
        <img className={className} height={height} alt={img.id} src={placeholderImage} />
      ) : null}
      <img
        onClick={() => {
          onClick(img);
        }}
        alt={img.id}
        className={className}
        src={img.url}
        style={!loaded ? { visibility: "hidden", display: "none" } : {}}
        onLoad={() => setLoaded(true)}
        height={height}
      />
    </>
  );
};

export default StableImage;
